import { render, staticRenderFns } from "./ComissionTixian.vue?vue&type=template&id=ad128244&"
import script from "./ComissionTixian.vue?vue&type=script&lang=js&"
export * from "./ComissionTixian.vue?vue&type=script&lang=js&"
import style0 from "./ComissionTixian.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports